export function validacionDNIS(AlumnoDNI, TutorDNI, reCaptchaToken) {
    if (AlumnoDNI === "1234567" && TutorDNI === "1234567" && reCaptchaToken.length > 0) {
        return { estado: true, mensaje: "documento" };
    } else if (AlumnoDNI === "12345678" && TutorDNI === "1234567" && reCaptchaToken.length > 0) {
        return { estado: true, mensaje: "tracking" };
    } else {
        return { estado: false, mensaje: "Los valores ingresados no son validos" };
    };
};

export function verificarEntero(entero) {
    if (entero.length > 0) {
        const enteroSoloNumeros = parseInt(entero, 10);//TRANSFORMO A ENTERO (SOLO NúMEROS)
        if (isNaN(enteroSoloNumeros)) {
            return { estado: false, valor: "" };
        } else {
            return { estado: true, valor: enteroSoloNumeros.toString() };
        };
    } else {
        return { estado: true, valor: "" };
    };
};

export function validarLongitudEntero(longitud, min = 1, max = 15) {
    if (longitud > 0 && longitud < min) {
        return { estado: false, mensaje: "Los caracteres debern ser igual o mayor a ", min };
    } else if (longitud >= min && longitud <= max) {
        return { estado: true, mensaje: "Cumple longitudes" };
    } else if (longitud > max) {
        return { estado: false, mensaje: "Los caracteres debern ser igual o menor a ", max };
    } else {
        return { estado: false, mensaje: "" };
    };
};